import { escapeHashSelector, getUrlParameter } from './url-helper';

jQuery(($) => {
    function accordions () {
        $('.accordion').accordion({
            header: '.accordion-header',
            collapsible: true,
            heightStyle: 'content',
            active: false,
            animate: false
        });

        if (window.location.hash) {
            const $accordionParent = $(escapeHashSelector(window.location.hash));
            if ($($accordionParent).hasClass('accordion-item')) {
                setAccordionExpanded($accordionParent, true);
                scrollToAccordion($accordionParent);
            }
        }

        if (getUrlParameter('AccordionItem')) {
            const accordionID = getUrlParameter('AccordionItem');
            const $accordionParent = $(`#AccordionItem${accordionID}`);

            setAccordionExpanded($accordionParent, true);

            if (getUrlParameter('scroll')) {
                scrollToAccordion($accordionParent);
            }
        }

        function scrollToAccordion ($accordionParent) {
            $('html, body').animate({
                scrollTop: $($accordionParent).offset().top
            }, 2000);
        }

        $('.manage-all-accordions').on('click', function () {
            $(this).toggleClass('active');

            const showAllAccordions = $(this).hasClass('active');
            document.getElementById('toggle-accordions').innerHTML = showAllAccordions ? 'Hide All' : 'Show All';

            const accordions = $('.accordion-item > .ui-accordion-header-icon');
            for (let i = 0; i < accordions.length; i++) {
                const accordion = accordions[i];

                const isOpen = $(accordion).parent().hasClass('active');
                if (showAllAccordions) {
                    if (!isOpen) {
                        $(accordion).click();
                    }
                } else if (isOpen) {
                    $(accordion).click();
                }
            }
        });
    }

    $('.subscribe-form .ui-accordion-header-icon').on('click', function (event) {
        const parent = $(this).parent();
        const fieldgroup = $(parent).siblings('.last');
        const childrenholder = $(fieldgroup).find('.accordion-content');
        $(childrenholder).toggle();
        $(this).toggleClass('active');
    });

    $(document).ready(() => {
        accordions();
        addAccordionsClickHandlers();

        const id = escapeHashSelector(window.location.hash);
        const potentialAccordionItem = $(id);

        if (potentialAccordionItem.hasClass('accordion-item')) {
            potentialAccordionItem.css('display', 'block');
            potentialAccordionItem.closest('.ui-accordion-header-icon').addClass('active');
        }
    });
});

export function setAccordionExpanded ($accordionParent, expanded) {
    $accordionParent.toggleClass('active', expanded)
        .children('.accordion-content', expanded)
        .toggleClass('ui-accordion-content-active', expanded)
        .attr('aria-hidden', (!expanded).toString())
        .attr('style', `display: ${expanded ? 'block' : 'none'};`);

    $accordionParent.children('.accordion-header')
        .toggleClass('ui-accordion-header-active', expanded)
        .toggleClass('ui-state-active', expanded)
        .toggleClass('ui-corner-top', expanded)
        .attr('aria-selected', expanded.toString())
        .attr('aria-expanded', expanded.toString())
        .attr('style', 'display: block;');

    $accordionParent.children('.accordion-share').attr('style', `display: ${expanded ? 'inline-block' : 'none'};`);

    $accordionParent.children('.ui-accordion-header-icon').attr('aria-expanded', expanded.toString());
}

export function addAccordionsClickHandlers () {
    $('.ui-accordion-header-icon').each(function () {
        const $this = $(this);
        const $accordionParent = $this.parent('.accordion-item');

        // Disable click and keyboard functions provided by accordion js for the header
        $accordionParent.children('.accordion-header').prop('onclick', null).off('click');
        $accordionParent.children('.accordion-header').removeAttr('tabindex', '0');

        $this.on('click', () => {
            setAccordionExpanded($accordionParent, !$accordionParent.hasClass('active'));

            if ($('#toggle-accordions').length > 0) {
                const accordion = $accordionParent.parent('.accordion');
                const areAllAccordionsOpen = accordion.find('.include-read-more').length === accordion.find('.include-read-more.active').length;

                document.getElementById('toggle-accordions').innerHTML = areAllAccordionsOpen ? 'Hide All' : 'Show All';
                if (areAllAccordionsOpen) {
                    $('.manage-all-accordions').addClass('active');
                } else {
                    $('.manage-all-accordions').removeClass('active');
                }
            }
        });
    });
}



// WEBPACK FOOTER //
// ./src/js/app/accordion.js